import { connect, MapDispatchToProps, MergeProps } from "react-redux";

import { IconEditComponent, IconEditComponentProps } from "../IconEditComponent";
import { createOpenFormIconEditAction } from "./actions";
import { IconEditProps } from "./IconEdit";

type IconEditConnectProps = Pick<IconEditProps, "uuid" | "isEditing" > & IconEditComponentProps;

type DispatchProps = {
    openFormIconEdit: typeof createOpenFormIconEditAction;
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, IconEditConnectProps> = (dispatch) => ({
    openFormIconEdit: (uuid) => dispatch(createOpenFormIconEditAction(uuid)),
});

const mergeProps: MergeProps<undefined, DispatchProps, IconEditConnectProps, IconEditComponentProps> = (
    _stateProps,
    { openFormIconEdit },
    { onClick, uuid, isEditing, ...restOwnProps }) => ({
    onClick: isEditing ? (e) => {
        openFormIconEdit(uuid);
        onClick && onClick(e);
    } : onClick,
    ...restOwnProps,
});

export const IconEditConnected = connect(null, mapDispatchToProps, mergeProps)(IconEditComponent);
